<template>
  <!-- Views/Tabs container -->

  <f7-page no-toolbar no-swipeback name="deposit-qa" class="deposit-qa-info">
    <f7-navbar :no-hariline="true" innerClass="inner-bankInfo">
      <f7-nav-left>
        <f7-link @click="back">
          <i class="f7-icons">chevron_left</i>
        </f7-link>
      </f7-nav-left>
      <f7-nav-title>{{ $t("deposit_qa_0001") }}</f7-nav-title>
    </f7-navbar>
    <div v-show="showUI == true" class="deposit-balance-bgimg">
      <ul>
        <li>
          <span v-if="totalBalance == -99999">--</span>
          <span v-else>${{ totalBalance }}</span>
        </li>
        <li>
          <span>{{ $t("member_center_0046") }}</span>
        </li>
      </ul>
    </div>
    <f7-block v-show="showUI == true" class="deposit-info">
      <div class="form">
        <div class="form-item input-amt">
          <div class="item-inner inner-amt">
            <div class="item-title item-label item-amt">$</div>
            <div class="item-input-wrap">
              <input class="input-amt" type="number" :placeholder="$t('deposit_0060')" v-model="bankTransferForm.Amount" />
            </div>
          </div>
        </div>
        <div class="form-item">
          <div block class="item-amount-quick">
            <ul>
              <li>
                <div :class="{ active: 1000 === bankTransferForm.Amount }" @click="toggleAmount(1000)"><span style="">$1000</span></div>
              </li>
              <li>
                <div :class="{ active: 3000 === bankTransferForm.Amount }" @click="toggleAmount(3000)"><span>$3000</span></div>
              </li>
              <li>
                <div :class="{ active: 5000 === bankTransferForm.Amount }" @click="toggleAmount(5000)"><span>$5000</span></div>
              </li>
              <li>
                <div :class="{ active: 10000 === bankTransferForm.Amount }" @click="toggleAmount(10000)"><span>$10000</span></div>
              </li>
              <li>
                <div :class="{ active: 30000 === bankTransferForm.Amount }" @click="toggleAmount(30000)"><span>$30000</span></div>
              </li>
              <li>
                <div :class="{ active: 50000 === bankTransferForm.Amount }" @click="toggleAmount(50000)"><span>$50000</span></div>
              </li>
            </ul>
          </div>
        </div>
        <div class="form-item pay-notice">
          <div class="item-inner">
            <div class="item-title item-label">{{ $t("deposit_qa_0004") }}</div>
          </div>
        </div>
        <div class="form-item">
          <div class="pay-method">
            <span class="checkbox-item" key="1">
              <label class="checkbox">
                <input type="checkbox" :checked="checkBankCodeATM" name="name1" @change="changeBank('ATM')" />
                <i class="icon-checkbox"></i>
              </label>
            </span>
            <div class="pay-title" style="">{{ $t("deposit_qa_0003") }}</div>
            <div class="pay-info" style="">
              <ul>
                <li style="">
                  <img src="../../../static/images/yt999/pay/pay_1.png" style="" />
                  <!-- <i style="background: url(../../../static/images/yt999/pay/pay_1.png); background-size: cover;"></i> -->
                </li>
                <li style="">
                  <img src="../../../static/images/yt999/pay/pay_2.png" style="" />
                </li>
                <li style="">
                  <img src="../../../static/images/yt999/pay/pay_3.png" style="" />
                </li>
                <li style="">
                  <img src="../../../static/images/yt999/pay/pay_4.png" style="" />
                </li>
              </ul>
            </div>
          </div>
          <div class="pay-method">
            <span class="checkbox-item" key="2">
              <label class="checkbox">
                <input type="checkbox" :checked="checkBankCodeBCTFS" name="name2" @change="changeBank('BCTFS')" />
                <i class="icon-checkbox"></i>
              </label>
            </span>
            <div class="pay-title" style="">{{ $t("deposit_qa_0002") }}</div>
            <div class="pay-info" style="">
              <ul>
                <li style="">
                  <img src="../../../static/images/yt999/pay/pay_5.png" style="" />
                  <!-- <i style="background: url(../../../static/images/yt999/pay/pay_1.png); background-size: cover;"></i> -->
                </li>
                <li style="">
                  <img src="../../../static/images/yt999/pay/pay_6.png" style="" />
                </li>
                <li style="">
                  <img src="../../../static/images/yt999/pay/pay_7.png" style="" />
                </li>
                <li style="">
                  <img src="../../../static/images/yt999/pay/pay_8.png" style="" />
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="form-item confirm-notice">
          <div class="item-inner">
            <div class="item-title item-label">{{ $t("deposit_qa_0006") }}</div>
            <div class="item-title item-label">{{ $t("deposit_qa_0007") }}</div>
          </div>
        </div>
        <div class="list inset button-save">
          <ul>
            <li>
              <a href="#" class="list-button button-single" @click="bankTransferSubmit()" click="bankInfoSubmit">
                <span style="display: inline-block">{{ $t("apply_activity_0005") }}</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </f7-block>
    <!-- <div class="block accordion-list">
          <div class="accordion-item" v-for="item in depositqaList" :key="item.QID">
            <div class="accordion-item-toggle">
              <div class="row no-gap">                 
                <div class="col-90 text-left col-title" style="padding: 10px;width: 100%;">
                  <img class="help" src="../../../static/images/yt999/help.png">
                  <div class="s-title">{{ item.CnName_Title }}</div>
                </div>
              </div>
            </div>
            <div class="accordion-item-content">
                  <div block class="ans" style="margin: 5px 10px 20px 5px;word-break: break-all;word-wrap: break-word;width: 84%;margin: auto;margin-bottom: 20px;">{{ item.CnName_Answer }}</div>
            </div>
          </div>
        </div>   -->
    <!-- 在线客服popup -->
    <f7-popup v-show="showOnlineCustomPopup" class="onlineCustom-popup" :opened="onlinePopupOpened" @popup:open="openOnlineCustomPopup" @popup:close="closeOnlineCustomPopup">
      <f7-page>
        <f7-navbar :title="$t('app_0016')">
          <f7-nav-right>
            <f7-link popup-close><i class="f7-icons">multiply_circle</i></f7-link>
          </f7-nav-right>
        </f7-navbar>
        <iframe :src="onlineCustomUrl" class="iframe-onlineCustom" frameborder="0"></iframe>
      </f7-page>
    </f7-popup>
  </f7-page>
</template>
<script>
import { getmemberwinloserp, depositqalist, payBankTransfer, memberwaitofflinepaymentget } from "../../../axios/api";
import { mapGetters } from "vuex";
import moment from "moment";
let self;
export default {
  components: {},
  props: {},
  data() {
    return {
      showUI: false,
      checkBankCodeATM: true,
      checkBankCodeBCTFS: false,
      bindBankInfoStatus: false,
      depositqaList: [],
      bankInfoForm: {
        BankAccountNo: "",
        SureName: "",
        BankAddress: "",
        BankName: "",
      },
      winloseParams: {
        DateRangeType: 1,
      },
      winloseInfo: {},
      totalBalance: -99999,
      bankTransferForm: {
        BankId: 0,
        BankCode: "ATM",
        TransferType: 6,
        PayType: 1,
        Amount: "",
        BankAccountNo: "--",
        AccountName: "--",
        PromotionId: 0,
        RealDepositRate: 1,
        DepositTs: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
      },
      memberBankCardList: [],
      onlinePopupOpened: false,
      onlineCustomUrl: "",
      SureNameFlag: false,
      showOnlineCustomPopup: true,
    };
  },
  watch: {},
  computed: {
    ...mapGetters(["getMerchantInfo", "onlineCustomLoaded"]),
  },
  methods: {
    onCopy(e) {
      if (e.text) {
        let copyLoading = self.$f7.dialog
          .create({
            title: "",
            text: this.$t("common_0003"),
            cssClass: "dialog-preloadgame",
          })
          .open();

        setTimeout(() => {
          copyLoading.close();
        }, 1000);
      }
    },
    onError(e) {
      console.log(e);
    },
    changeBank(item) {
      if (item == "ATM") {
        this.checkBankCodeATM = true;
        this.checkBankCodeBCTFS = false;
        this.bankTransferForm.BankCode = "ATM";
      } else {
        this.bankTransferForm.BankCode = "BCTFS";
        this.checkBankCodeATM = false;
        this.checkBankCodeBCTFS = true;
      }
    },
    toggleAmount(value) {
      if (value == "") {
        return;
      }
      this.bankTransferForm.Amount = value;
    },
    getDepositQAListEvent() {
      const self = this;
      depositqalist().then((data) => {
        if (data.Code === "NoError") {
          self.depositqaList = data.Data;
        }
      });
    },
    openServiceAction() {
      const self = this;
      const baseInfo = self.getMerchantInfo.BaseInfo;
      // self.customerService = {
      //   WeChat: {
      //     'QR': (baseInfo && baseInfo.WeChatCS_QR) ? baseInfo.WeChatCS_QR.split('|') : [],
      //     'NickName': (baseInfo && baseInfo.WeChatCS_NickName) ? baseInfo.WeChatCS_NickName.split('|') : [],
      //     'Account': (baseInfo && baseInfo.WeChatCS) ? baseInfo.WeChatCS.split('|') : [],
      //   },
      //   QQ: {
      //     'QR': (baseInfo && baseInfo.QQ_QR) ? baseInfo.QQ_QR.split('|') : [],
      //     'NickName': (baseInfo && baseInfo.QQ_NickName) ? baseInfo.QQ_NickName.split('|') : [],
      //     'Account': (baseInfo && baseInfo.QQ) ? baseInfo.QQ.split('|') : [],
      //   }
      // }
      // self.actionServiceOpened = true;
      // self.onlineCustomUrl = baseInfo.MobileService;
      if (baseInfo.CSType == 2) {
        if (!this.onlineCustomLoaded) {
          let loading = self.$f7.dialog
            .create({
              title: "",
              text: "Loading...",
              cssClass: "dialog-preloadgame",
            })
            .open();
          setTimeout(() => {
            loading.close();
            this.openServiceAction();
          }, 1500);
        } else {
          window.Tawk_API.toggle();
        }
      } else {
        self.onlineCustomUrl = baseInfo.MobileService;
        self.onlinePopupOpened = true;
      }
    },
    getMemberWinloseRP() {
      const self = this;
      self.totalBalance = -99999;
      self.showWinlose = false;
      const param = { data: JSON.stringify(self.winloseParams) };
      getmemberwinloserp(param).then((data) => {
        if (data.Code === "NoError") {
          self.winloseInfo = data.Data;
          self.totalBalance = self.winloseInfo[0].TotalBalance;
        }
      });
    },
    bankTransferSubmit() {
      const self = this;
      if (!self.bankTransferForm.Amount) {
        self.$f7.dialog.alert(this.$t("deposit_0060"), this.$t("common_0004"));
        return false;
      }
      const param = { data: JSON.stringify(this.bankTransferForm) };
      let promtLoadingGame = self.$f7.dialog
        .create({
          title: "",
          text: this.$t("Order_0017"),
          cssClass: "dialog-preloadorder",
        })
        .open();
      self.$f7.params.dialog.closeByBackdropClick = false;
      //self.$f7.$('.dialog-backdrop').css('background-color', 'transparent');

      payBankTransfer(param).then((data) => {
        self.$f7.params.dialog.closeByBackdropClick = true;
        //self.$f7.$('.dialog-backdrop').css('background-color', 'rgba(0, 0, 0, 0.74)');
        promtLoadingGame.close();

        if (data.Code === "NoError") {
          // self.$f7.dialog.alert(this.$t('deposit_0056'), this.$t('common_0004'));
          self.$f7router.navigate("/member-center/deposit-details/");
          self.bankTransferForm.AccountName = "";
          self.bankTransferForm.Amount = "";
          self.bankTransferForm.BankAccountNo = "";
        } else if (data.Code === "Exist" || data.Code === "DepositSubmitLimit") {
          self.$f7.dialog.confirm(
            this.$t("deposit_qa_0008"),
            this.$t("common_0004"),
            () => {
              self.$f7router.navigate("/member-center/deposit-details/");
            },
            () => {
              // self.$f7router.back();
            }
          );
        } else {
          self.$f7.dialog.alert(data.Data, this.$t("common_0004"));
        }
      });
    },
    onlineCustomService() {
      const self = this;
      self.$f7.actions.close(".actions-qq");
      self.$f7.actions.close(".actions-wechat");
      self.onlinePopupOpened = true;
    },
    back() {
      if (this.$f7route.params.Id == 0) {
        this.$f7router.back();
      } else {
        this.$f7router.navigate("/member-center/");
      }
    },
    openOnlineCustomPopup() {
      this.showOnlineCustomPopup = true;
    },
    closeOnlineCustomPopup() {
      this.onlinePopupOpened = false;
      this.showOnlineCustomPopup = false;
    },
  },
  created() {
    self = this;
    this.totalBalance = -99999;
    var depositFlag = sessionStorage.getItem("deposit-flag") ?? "";
    console.log(depositFlag);
    if (depositFlag === "") {
      sessionStorage.removeItem("deposit-flag");
      memberwaitofflinepaymentget().then((data) => {
        if (data.Code === "NoError") {
          if (data.Data.TicketNo) {
            self.$f7router.navigate("/member-center/deposit-details/");
          } else {
            this.showUI = true;
          }
        }
      });
    } else {
      sessionStorage.removeItem("deposit-flag");
      this.showUI = true;
    }
    this.getDepositQAListEvent();
    this.getMemberWinloseRP();
  },
  mounted() {},
  updated() {},
};
</script>
<style lang="less" scoped>
.deposit-qa-info {
  --f7-page-toolbar-bottom-offset: 0;

  .deposit-balance-bgimg {
    width: 95%;
    margin: auto;
    text-align: center;
    margin-top: 10px;
    background-color: #e5e4dc;
    background-size: cover;
    border-radius: 10px;
    ul {
      span {
        font-family: "Cairo";

        color: #000;
      }
      li:nth-child(1) {
        padding: 20px 20px 0px 20px;
        span {
          font-weight: 500;
          font-size: 24px;
          line-height: 21px;
        }
      }
      li:nth-child(2) {
        padding: 5px 20px 10px 20px;
        span {
          font-weight: 400;
          font-size: 14px;
          line-height: 26px;
        }
      }
    }
  }
  .deposit-info {
    margin: 10px 12px 12px;
    padding: 0;
    .form {
      .input-amt {
        margin-top: 30px;
      }
      .pay-notice {
        margin-top: 15px;
        margin-bottom: 15px;
        .item-label {
          font-size: 16px;
          font-weight: 550;
          margin-left: 3px;
        }
      }
      .confirm-notice {
        margin-top: 15px;
        margin-bottom: 15px;
        .item-label {
          font-size: 15px;
          font-weight: 550;
          text-align: center;
          color: #5f5f5f;
        }
      }
      .item-inner {
        .input-amt {
          width: 95%;
          line-height: 24px;
          margin: auto;
          border-bottom: 1px solid #cecece;
        }
        hr {
          border: 1px solid rgb(206, 206, 206);
          position: absolute;
          width: 96%;
          top: 30px;
          border-top: 1px;
          text-align: center;
        }

        ul {
          li:nth-child(1) {
            float: left;
            margin-left: 10px;
            margin-right: 10px;
            span {
              font-weight: 700;
              font-size: 20px;
              line-height: 21px;
              text-align: center;
              color: #000000;
            }
          }
          li:nth-child(2) {
            float: left;
            margin-right: 30px;
            width: 80%;
            margin-bottom: 20px;
          }
        }
      }
      .inner-amt {
        position: relative;
        .item-amt {
          position: absolute;
          left: 2%;
          top: -6px;
          font-size: 24px;
          font-weight: 500;
        }
      }

      .item-amount-quick {
        width: 100%;
        height: 90px;
        margin: auto;
        ul {
          li {
            float: left;
            width: 31%;
            padding: 1%;
            text-align: center;
            div {
              border: 1px solid rgb(206, 206, 206);
              border-radius: 5px;
              padding: 6px 12px 6px 12px;
            }
            span {
              font-weight: 600;
              font-size: 15px;
              line-height: 21px;
            }
          }
        }
        .active {
          background-color: #e5e4dc;
          // background: url(../../../static/images/yt999/active_bg.png) no-repeat;
          // background-size: 100% 100%;
          // border: 1px solid #ffc107;
          span {
            color: #000;
          }
        }
      }

      .pay-method {
        background: #eeeeee;
        border-radius: 5px;
        height: 90px;
        position: relative;
        margin-bottom: 6px;
        .checkbox-item {
          display: flex;
          justify-content: flex-end;
          align-items: center;
          height: 100px;
          margin-right: 3%;
        }
        .pay-title {
          padding: 10px 0px 0px 20px;
          font-family: "Poppins";
          font-weight: 500;
          font-size: 14px;
          line-height: 21px;
          color: #000000;
          position: absolute;
          left: 0;
          top: 0;
        }

        .pay-info {
          padding: 10px 0px 0px 10px;
          position: absolute;
          left: 0px;
          top: 35px;
          ul {
            li {
              float: left;
              margin-left: 10px;
              margin-right: 10px;
              width: 28px;
              img {
                width: 28px;
                height: 28px;
              }
            }
          }
          .item-input-wrap {
            .checkbox-item {
              .checkbox {
                position: absolute;
                // width: 16px;
                // height: 16px;
                left: 350px;
                top: 240px;
              }
              .checkbox i {
                border: 1px solid #3265ce;
              }
            }
          }
        }
      }

      .item-title {
        color: #464646;
      }
      .item-input-wrap {
        // width: 100%;
        // background: #fafafa;
        // border: 1px solid #1b2a3b10;
        // padding: 10px;
        // border-radius: 6px;
        margin: 2px 0 10px;
        width: 100%;
        input {
          width: 100%;
          text-align: center;

          font-weight: 500;
          font-size: 18px;
          line-height: 21px;
          color: #464646;
        }
        input[type="number"]::placeholder {
          text-align: center;

          font-weight: 500;
          font-size: 18px;
          line-height: 21px;
          color: #c0c0c0;
        }
      }
      .smart-select .item-after {
        max-width: unset;
      }
    }
  }
  .qaimg {
    width: 95%;
    margin: auto;
    border-radius: 5px;
    text-align: center;
    margin-top: 10px;
    img {
      border-radius: 5px;
      max-width: 100%;
      max-height: 100%;
      width: 100px;
      height: auto;
      min-width: 100%;
      min-height: 100%;
    }
  }

  .qalist {
    background: #f1f1f1;
    ul {
      background: #f1f1f1;
    }
  }
  .statistics {
    width: 95%;
    margin: auto;
    background: #f1f1f1;
    border-radius: 5px;
    text-align: center;
    margin-top: 10px;

    .title {
      text-align: center;
      font-size: 18px;
      padding-top: 6px;
      font-weight: bold;
      color: #ad5c09;
    }
    .amount {
      text-align: center;
      font-size: 18px;
      padding-top: 6px;
      font-weight: bold;
      color: #ad5c09;
    }
    .desc {
      border-top: 1px solid #e0dbdb;
      margin-top: 10px;
      .p1 {
        margin: 10px;
        font-weight: bold;
      }
      .p2 {
        margin-left: 10px;
        margin-right: 10px;
        padding-bottom: 10px;
        word-wrap: break-word;
      }
    }
  }
  .accordion-list {
    //background-color: #EEEEEE;
    margin-top: 20px;
    border-radius: 5px;
    width: 100%;
    margin: auto;
    .accordion-item {
      border-bottom: 1px solid #f0f0f0;
      .col-title {
        position: relative;
        .help {
          position: absolute;
          left: 0px;
          border-radius: 5px;
          width: 19px;
          height: auto;
          vertical-align: middle;
        }
        .s-title {
          width: 94%;
          margin-left: 15px;
          margin-top: -1px;
          font-size: 15px;
          color: #464646;
          text-decoration: underline;
          word-break: break-all;
          word-wrap: break-word;
        }
        .accordion-item-content {
          .ans {
            width: 100%;
            margin-left: 10px 10px 10px 10px;
            // word-break: break-all;
            // word-wrap: break-word;
          }
        }
      }
    }
  }
  .bank-card {
    margin: 0px;
    background: -webkit-linear-gradient(#6d9af6, #6d9af6);
    background: -o-linear-gradient(#6d9af6, #6d9af6);
    background: -moz-linear-gradient(#6d9af6, #6d9af6);
    background: -mos-linear-gradient(#6d9af6, #6d9af6);
    background: linear-gradient(#6d9af6, #6d9af6);
    border-radius: 8px;
    color: #fff;

    .card-header {
      justify-content: flex-start;
      margin: 0 12px;
      padding-right: 0;
      padding-left: 0;
      border-bottom: 1px solid #5e89e1;

      .card-avatar {
        img {
          vertical-align: middle;
        }
      }

      .card-name,
      .card-accountname {
        margin: 0 10px;
        font-size: 16px;
        position: relative;
      }

      .card-name:after {
        content: "";
        position: absolute;
        width: 1px;
        height: 15px;
        background-color: #fff;
        right: -10px;
        top: 4px;
        display: block;
      }
    }

    .card-header:after {
      height: 0;
    }

    .card-content {
      .card-info {
        margin: 6px 10px;
        padding: 5px 0;
      }

      .card-address {
        margin: 6px 14px;
      }
    }

    .card-footer {
      padding: 15px 8px;

      .block {
        width: 100%;

        .button {
          background-color: #3569cf;
          color: #ffffff;
        }
      }
    }

    .card-footer:before {
      height: 0;
    }
  }
  .block-bank-title {
    color: #e42f2f;
    margin: 20px 0 10px;
  }
  .block-bank-info {
    margin: 5px 0 10px;
    padding: 0 10px;
    .list-bank-info {
      margin: 0;
      ul {
        background-color: transparent;
        .item-input {
          .item-inner {
            .item-title {
              padding-top: 8px;
              color: #464646;
              width: 25%;
              padding-right: 5px;
            }
            input {
              color: #464646;
              font-size: 14px;
            }
          }
          .item-inner:after {
            height: 0;
          }
        }
        .smart-select {
          .item-content {
            .item-inner {
              .item-after {
                width: 69%;
                color: #464646;
                font-size: 14px;
              }
            }
            .item-inner:after {
              height: 0;
            }
          }
        }
        .smart-select.active-state {
          background-color: transparent;
        }
        .item-title {
          color: #464646;
          font-size: 15px;
          text-align: right;
          width: 27%;
        }
      }
      ul:before,
      ul:after {
        height: 0;
      }
    }
  }
  .button-save {
    margin: 20px 0px;

    ul {
      background: var(--f7-button-bg-color);
      li {
        a {
          color: var(--f7-button-text-color);
        }
      }
    }
  }
}
</style>
